import _ from 'lodash'

const state = {
    totalItems: [],
    itemsNotSelectedInBack: [],
    itemIsSelectedInBack: [],
    itemUnSelected: [],
    itemSelected: []
}

const getters = {
    getTotalItems(state) {
        return state.totalItems
    },

    getItemsNotSelectedInBack(state) {
        return state.itemsNotSelectedInBack
    },

    getItemIsSelectedInBack(state) {
        return state.itemIsSelectedInBack
    },

    getItemUnSelected(state) {
        return state.itemUnSelected
    },

    getItemSelected(state) {
        return state.itemSelected
    }
}

const mutations = {
    SET_ITEM_UNSELECTED(state, value) {
        let result = state.itemIsSelectedInBack.findIndex(data => data.product.id === value.product.id)
        state.itemIsSelectedInBack.splice(result, 1)
        state.itemUnSelected.push(value)
    },

    SET_ITEM_SELECTED(state, value) {
        let result = state.itemUnSelected.findIndex(data => data.product.id === value.product.id)
        if (result === -1) {
            state.itemSelected.push(value)
        } else {
            state.itemIsSelectedInBack.push(state.itemUnSelected[result])
            state.itemUnSelected.splice(result, 1)
        }
    },

    REMOVE_ITEM(state, obj) {
        let result = state.itemSelected.findIndex(data => data.product.id === obj.product.id)
        if (result !== -1) {
            state.itemSelected.splice(result, 1)
        }
    }
}

const actions = {
    itemUnselected: function ({ state, commit }, data) {
        const result = _.differenceWith(
            state.itemIsSelectedInBack,
            data, (a, b) => _.isEqual(_.omit(a, ['frontIsSelected']), b, ['frontIsSelected']))

        if (result.length > 0) {
            commit('SET_ITEM_UNSELECTED', ...result)
        }
    },

    itemSelected: function ({ commit }, data) {
        commit('SET_ITEM_SELECTED', data)
    },

    removeItem: function ({ commit }, item) {
        commit('REMOVE_ITEM', item)
    }
}

const stockRanking = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}

export default stockRanking
export { stockRanking }
